export default "__VITE_ASSET__AzNyI2XM__"